import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from '@coveord/plasma-mantine';
import { Locales } from '../../../strings/Locales.js';
export var EditConfirmationPromptConfirmButton = function EditConfirmationPromptConfirmButton(param) {
    var onClick = param.onClick, loading = param.loading;
    return /*#__PURE__*/ _jsx(Prompt.ConfirmButton, {
        onClick: onClick,
        loading: loading,
        children: Locales.format('EditConfirmationPrompt.footer.button.save')
    });
};
EditConfirmationPromptConfirmButton.displayName = 'EditConfirmationPrompt.ConfirmButton';

//# sourceMappingURL=EditConfirmationPromptConfirmButton.js.map